import React from 'react';

import { LegalContainer } from './Legal.styled';
import kindbody from 'assets/logos/kindbody.svg';
import { useBreakpoints } from 'utilities/useBreakpoints';

export const Logo = () => {
  const { isDesktop } = useBreakpoints();

  return (
    <LegalContainer>
      <a
        href="https://kindbody.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Kindbody website (opens in new tab)"
      >
        <img src={kindbody} alt="" height={isDesktop ? '16px' : '24px'} />
      </a>
    </LegalContainer>
  );
};
